export default __webpack_public_path__ + "static/media/auth-bg.e96d7c3a.jpg";